import React from 'react';
import { iNotification, ReactNotifications, Store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import { FC, PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';

/**
 * Show a notification
 *
 * @param settings The notification settings
 */
const notificationsPortal = document.createElement('div');
notificationsPortal.id = 'notifications-portal';
document.body.appendChild(notificationsPortal);

export function showNotification(settings: Partial<iNotification>) {
    return Store.addNotification.call(Store, {
        container: 'top-right',
        animationIn: ['animate__animated', 'animate__fadeIn'], // animate.css classes that's applied
        animationOut: ['animate__animated', 'animate__fadeOut'], // animate.css classes that's applied
        ...settings
    });
}

export function showInfoNotification(settings: Partial<iNotification>) {
    return showNotification({
        type: 'default',
        dismiss: {
            duration: 5000
        },
        ...settings
    });
}

export function showSuccessNotification(settings: Partial<iNotification>) {
    return showNotification({
        type: 'success',
        dismiss: {
            duration: 5000
        },
        ...settings
    });
}

export function showWarningNotification(settings: Partial<iNotification>) {
    return showNotification({
        type: 'warning',
        dismiss: {
            duration: 5000
        },
        ...settings
    });
}

export function showErrorNotification(settings: Partial<iNotification>) {
    return showNotification({
        type: 'danger',
        dismiss: {
            duration: 5000
        },
        ...settings
    });
}

/**
 * Hide a notification
 *
 * @param id The notification id returned from showNotification
 */
export function removeNotification(id: string) {
    Store.removeNotification(id);
}

export type Notification_Type = 'success' | 'danger' | 'info' | 'default' | 'warning';

export interface NotificationToasterProps {
    type: Notification_Type;
    title?: string;
    message: string;
    duration?: number;
}

export function NotificationToaster({ type, title, message, duration }: PropsWithChildren<NotificationToasterProps>) {
    return showNotification({
        type: type,
        title: title,
        message: message,
        dismiss: {
            duration: duration ?? 5000
        }
    });
}

export const NotificationToasterRenderer: FC = () => {
    return <>{createPortal(<ReactNotifications />, notificationsPortal)}</>;
};
